/**
 * Display helpers.
 *
 * Note: name *normalisation* for search deliberately lives in SQL
 * (`jmc_normalize_name`), not here. The normalised column is a generated column
 * and queries normalise the search term the same way, so there is exactly one
 * implementation and it cannot drift from what is indexed.
 */
/** `9876543210` -> `98xxxxx210`. Never show a full mobile number in a list. */
export function maskMobile(mobile) {
    if (!mobile)
        return '—';
    const digits = mobile.replace(/\D/g, '').slice(-10);
    if (digits.length !== 10)
        return '—';
    return `${digits.slice(0, 2)}xxxxx${digits.slice(7)}`;
}
/** Financial year `2018-2019` -> starting year `2018`. */
export function financialYearStart(fy) {
    if (!fy)
        return null;
    const match = /^(\d{4})/.exec(fy.trim());
    if (!match?.[1])
        return null;
    const year = Number(match[1]);
    return year >= 1900 && year <= 2200 ? year : null;
}
const DATE_FMT_EN = new Intl.DateTimeFormat('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
});
const DATETIME_FMT_EN = new Intl.DateTimeFormat('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
});
export function formatDate(value) {
    if (!value)
        return '—';
    const date = typeof value === 'string' ? new Date(value) : value;
    if (Number.isNaN(date.getTime()))
        return '—';
    return DATE_FMT_EN.format(date);
}
export function formatDateTime(value) {
    if (!value)
        return '—';
    const date = typeof value === 'string' ? new Date(value) : value;
    if (Number.isNaN(date.getTime()))
        return '—';
    return DATETIME_FMT_EN.format(date);
}
/** Whole days from `date` until now; negative when the date is still ahead. */
export function daysOverdue(expected) {
    if (!expected)
        return 0;
    const due = new Date(`${expected}T23:59:59`);
    if (Number.isNaN(due.getTime()))
        return 0;
    const ms = Date.now() - due.getTime();
    return Math.floor(ms / 86_400_000);
}
/** Indian digit grouping: 123456 -> 1,23,456. */
export function formatCount(n) {
    return new Intl.NumberFormat('en-IN').format(n);
}
